export const getStopSubnav = (projectId: string, stopId: string, tourId?: string) => {
  const tourPath = tourId ? `/tour/${tourId}` : ''

  return [
    {
      title: 'Stop Details',
      to: `/project/${projectId}${tourPath}/stop/${stopId}`
    },
    {
      title: 'Media Carousel',
      to: `/project/${projectId}${tourPath}/stop/${stopId}/media-carousel`
    },
    {
      title: 'Translations',
      to: `/project/${projectId}${tourPath}/stop/${stopId}/translations`
    },
    {
      title: 'Related Stops',
      to: `/project/${projectId}${tourPath}/stop/${stopId}/related-stops`
    },
  ]
}
